const RSVP = () => {
  const iframeContent = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>
        .rsvp-survey {
          min-height: 500px;
        }
        @media (min-width: 640px) {
          #my-rsvp {
            width: 28rem;
            min-width: 34rem !important;
            min-height: 400px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .rsvp-date {
          display: none;
        }
        .rsvp-form {
          h3 {
            font-size: 1.6rem !important;
          }
          label, input, p, button, span {
          font-size: 1.1rem !important;
          }
        }
        </style>
      </head>
      <body>
        <div id="rsvp-widget"></div>
        
        <script>
          (function (w, d, s, o, f, js, fjs) {
            w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments) };
            js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];
            js.id = o; js.src = f; js.async = 1; fjs.parentNode.insertBefore(js, fjs);
          }(window, document, 'script', 'oursvp', 'https://www.oursvp.app/widget/widget.js'));
          
          oursvp('init', {
            element: document.getElementById('rsvp-widget'),
            eventId: 'uJvN3nprX6vhs4AWi3Ew',
            showBackBtn: true,
            language: 'english'
          });
        </script>
      </body>
    </html>
  `;

  return (
    <>
      <div className="RSVP-container">
        <div className="Title">R.S.V.P.</div>
        <div className="RSVP-details">
          <div className="RSVP-info">
            <div className="RSVP-text">
              <h3>Please RSVP by April 10, 2026</h3>
              <p>If you have any problems with the RSVP, please text Sara at 786-714-6909.</p>
              <iframe
                srcDoc={iframeContent}
                style={{
                  width: '100%',
                  minHeight: '3000px',
                  border: 'none',
                  overflow: 'hidden'
                }}
                title="RSVP Widget"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RSVP;